import './Services.scss';
import {useRef, useState, useEffect} from 'react';
import {Stack, Accordion, Container, Card} from 'react-bootstrap';

function Services({setactivelink}) {
    const containerRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    
    // Original list of items
    const servicesData = [
        { id: 1, title:'Digital Marketing', 
            service1InfoStart: "Harness the power of digital platforms to reach your target audience with precision and creativity.",
            service1InfoEnd: "Deliver measurable results and help your brand stand out.",
            service1: "Social Media Management",
            service2: "Search Engine Optimization (SEO)",
            service3: "Pay-per-click (PPC) advertising",
            service4: "Email Marketing"
        },
        { id: 2, title:'Corporate Branding', 
            service1InfoStart: "Build a strong brand identity that reflects your company's values and vision.",
            service1InfoEnd: "Create a brand that resonates with your audience and sets you apart from the competition.",
            service1: "Logo Design",
            service2: "Brand Guidelines",
            service3: "Brand Messaging",
            service4: "Visual Identity Development",
        },
        { id: 3, title:'Website Design & Development', 
            service1InfoStart: "Create visually stunning and user-friendly websites that create a strong impression.",
            service1InfoEnd: "Modern, professional, and user-friendly designs, Seamless experience across mobile, tablet, and desktop.",
            service1: "UI/UX & Custom Design",
            service2: "Responsive Development",
            service3: "SEO-Friendly Build",
            service4: "Website Maintenance",
        },
        { id: 4, title:'Advertisement Campaigns', 
            service1InfoStart: "Develop compelling ad campaigns that capture attention and drive results.",
            service1InfoEnd: "We craft creative and impactful campaigns that effectively communicate your message and achieve your marketing objectives.",
            service1: "Cover Print Ads",
            service2: "Digital Ads",
            service3: "Outdoor Advertising",
            service4: "Video Production",
        },
        { id: 5, title:'Environment Graphics', 
            service1InfoStart: "Design immersive and engaging environmental graphics that enhance your space.",
            service1InfoEnd: "We transform your physical space into a visually appealing and matching environment that reflects your brand identity.",
            service1: "Signage Design",
            service2: "Wall Graphics",
            service3: "Wayfinding Systems",
            service4: "Interior Branding",
        },
        { id: 6, title:'Exhibition Panel Design', 
            service1InfoStart: "Craft eye-catching exhibition panels that showcase your brand and attract visitors.",
            service1InfoEnd: "We create visually striking and functional exhibition panels that gathers your audience.",
            service1: "Booth Design", 
            service2: "Display Graphics", 
            service3: "Interactive Elements", 
            service4: "Installation", 
        },
        { id: 7, title:'Presentations', 
            service1InfoStart: "We help you create professional and engaging presentations that captivate your audience and convey your message with clarity.",
            service1: "Corporate Presentation",
            service2: "Slide Design",
            service3: "Content Development",
            service4: "Animation",
            service5: "Multimedia Integration",
        },
    ];

    // Duplicate the array for a seamless loop
    const loopedServices = [...servicesData];

    useEffect(() => {
        const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
            setIsVisible(true);
            } else {
            setIsVisible(false); 
            }
        },
        { threshold: 0.2 } // Triggers when 20% of the section is visible
        );
    
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return () => {
        if (containerRef.current) {
            observer.unobserve(containerRef.current);
        }
        };
    }, []);

  return (
    <Stack setactivelink={setactivelink} id="services" gap={6} className="services">
        <Container className="py-4">         
            <h1 className="section-title">Services</h1>  
            <div ref={containerRef} className={`card-wrapper ${isVisible ? 'is-visible' : ''}`}>
                <Accordion defaultActiveKey="2">
                    {loopedServices.map((card, index) => (
                        <Accordion.Item eventKey={index.toString()} key={index}>
                            <Accordion.Header>
                                <div className='header-title'>{card.title}</div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <p>{card.service1InfoStart}</p>
                                <ul>
                                    <li>{card.service1}</li>
                                    <li>{card.service2}</li>
                                    <li>{card.service3}</li>
                                    <li>{card.service4}</li>
                                </ul>
                                <p>{card.service1InfoEnd}</p>
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}  
                </Accordion>            
            </div>                
        </Container>
      </Stack>
  );
}

export default Services;